import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useIsCopilotStandaloneChatPage } from 'shared/copilot/hooks/useIsCopilotStandaloneChatPage';
import { writeCopilotUrlState } from 'shared/copilot/utils/copilotUrlState';
import { usePathname } from 'shared/hooks/useRouterPath';
interface UseCopilotUrlStateMirrorArgs {
  isOpen: boolean;
  chatId: string | null;
}

/**
 * Mirrors the drawer's open state and chat id into `copilotIsOpen` / `copilotChatId`.
 *
 * React state is the source of truth; the URL is only read once on load (to seed that
 * state) and is written from here afterwards. Re-running on path and query (so also on same-page `changePath` calls that rewrite the query) re-applies the
 * params after any navigation, so they travel with the user without touching every link.
 * The fullscreen chat page owns its own URL (`/ai/chat/<id>`), so the drawer params are
 * stripped there.
 */
export const useCopilotUrlStateMirror = t0 => {
  const $ = _c(9);
  const {
    isOpen,
    chatId
  } = t0;
  const {
    pathnameWithQueryParams
  } = usePathname();
  const isStandalonePage = useIsCopilotStandaloneChatPage();
  let t1;
  if ($[0] !== chatId || $[1] !== isOpen || $[2] !== isStandalonePage) {
    t1 = () => {
      writeCopilotUrlState({
        isOpen: isOpen && !isStandalonePage,
        chatId
      });
    };
    $[0] = chatId;
    $[1] = isOpen;
    $[2] = isStandalonePage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== chatId || $[5] !== isOpen || $[6] !== isStandalonePage || $[7] !== pathnameWithQueryParams) {
    t2 = [isOpen, chatId, isStandalonePage, pathnameWithQueryParams];
    $[4] = chatId;
    $[5] = isOpen;
    $[6] = isStandalonePage;
    $[7] = pathnameWithQueryParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
};